import * as React from 'react';
import * as _ from 'lodash';
import FormDialog, {FormDialogProps} from 'cl-dialogs/FormDialog';
import FormSelect from 'cl-form/FormSelect/FormSelect';
import FormInput from 'cl-form/FormInput/FormInput';
import {ExtendedWrappedFieldExternalProps} from 'cl-form/FormFields';
import {createValidateRequired} from 'cl-form/validation/validators';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {useMemo} from 'react';
import {ColumnsType} from 'cl-table/redux/actions';
import AlphabeticalIcon from 'mdi-material-ui/Alphabetical';
import CursorDefaultClickIcon from 'mdi-material-ui/CursorDefaultClick';
import NumericIcon from 'mdi-material-ui/Numeric';

export interface CreateAttributeFormData {
  displayName: string;
  type: string;
}

interface CreateAttributeFromCsvProps {
  defaultAttributeName: string;
  handleDestinationAttributeChange: (value) => any;
}

interface CreateAttributeDialogProps extends FormDialogProps {
  columns: ColumnsType;
  createAttributeFromCsvProps?: CreateAttributeFromCsvProps;
}

const CreateAttributeDialog: React.FunctionComponent<CreateAttributeDialogProps> = ({
  columns,
  createAttributeFromCsvProps,
  ...props
}) => {
  let defaultAttributeName, handleDestinationAttributeChange;
  if (!_.isEmpty(createAttributeFromCsvProps)) {
    defaultAttributeName = createAttributeFromCsvProps.defaultAttributeName;
    handleDestinationAttributeChange = createAttributeFromCsvProps.handleDestinationAttributeChange;
  }
  const fields = useMemo((): ExtendedWrappedFieldExternalProps<keyof CreateAttributeFormData>[] => {
    if (columns) {
      return [
        {
          component: FormInput,
          name: 'displayName',
          label: columns['displayName'].displayName,
          props: {
            autoFocus: true,
            placeholder: 'Enter a meaningful name',
          },
        },
        {
          component: FormSelect,
          name: 'type',
          label: columns['type'].displayName,
          props: {
            options: _.map(columns['type'].options, props => {
              switch (props.value) {
                case 'shortString':
                  return {...props, icon: AlphabeticalIcon};
                case 'select':
                  return {...props, icon: CursorDefaultClickIcon};
                case 'float':
                  return {...props, icon: NumericIcon};
              }
            }),
          },
        },
      ];
    }
  }, [columns]) as any;

  return (
    <FormDialog
      validate={createValidateRequired(fields)}
      title="Create new attribute"
      initialValues={{displayName: defaultAttributeName}}
      fields={fields}
      formName={GENERAL_ACTIONS_TYPES.ADD_ATTRIBUTE}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.ADD_ATTRIBUTE]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          additionalActionData={{handleDestinationAttributeChange}}
        />
      }
      {...props}
    />
  );
};

export default CreateAttributeDialog;
